import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Accuracy } from 'app/models/generated'
import { logger } from '../../logging/Logger'

interface ConsultSliceState {
    // null until a template is picked (initialState / resetConsultState).
    readonly templateType?: string | null
    readonly catalogueTemplateId?: string | null
    readonly catalogueTemplateVersion?: number | null
    readonly isRunningConsult?: boolean
    readonly isPlayingAudio?: boolean
    readonly accuracy: Accuracy
}

const initialState: ConsultSliceState = {
    templateType: null,
    catalogueTemplateId: null,
    catalogueTemplateVersion: null,
    isRunningConsult: false,
    isPlayingAudio: false,
    accuracy: Accuracy.DEFAULT,
}

export const consultSlice = createSlice({
    name: 'consult',
    initialState: initialState,
    reducers: {
        setTemplate: (state, action: PayloadAction<string>) => {
            state.templateType = action.payload
        },
        setCatalogueTemplateId: (
            state,
            action: PayloadAction<string | null>
        ) => {
            state.catalogueTemplateId = action.payload
        },
        setCatalogueTemplateVersion: (
            state,
            action: PayloadAction<number | null>
        ) => {
            state.catalogueTemplateVersion = action.payload
        },
        setIsRunningConsult: (state, action: PayloadAction<boolean>) => {
            state.isRunningConsult = action.payload
        },
        setIsPlayingAudio: (state, action: PayloadAction<boolean>) => {
            state.isPlayingAudio = action.payload
        },
        setAccuracy: (state, action: PayloadAction<Accuracy>) => {
            logger.debug('Updating accuracy', {
                action: 'set_accuracy',
                metadata: { accuracy: action.payload },
            })
            state.accuracy = action.payload
        },
        resetConsultState: () => initialState,
    },
})

export const {
    setTemplate,
    setCatalogueTemplateId,
    setCatalogueTemplateVersion,
    setIsRunningConsult,
    setIsPlayingAudio,
    setAccuracy,
    resetConsultState,
} = consultSlice.actions

export const consultReducer = consultSlice.reducer
